// extracted by mini-css-extract-plugin
module.exports = {"root":"StatLabel_root__3n5cI","column1":"StatLabel_column1__2fEmx","name":"StatLabel_name__2ZYwQ","value":"StatLabel_value__2B9JH","countValue":"StatLabel_countValue__cmo-g"};